<template>
  <div class="page-template">
    <div class="page-head" :style="`background:${basic.mobileHeadBg?basic.mobileHeadBg:'#ff6034'}`">
      <!-- <h1 class="page-name">五个字标题</h1> -->
      <div class="page-search" @click="$router.push('/m/search')">
        <input type="text" class="head-inp" placeholder="搜索" />
        <van-icon name="search" color="#999999" size="0.4rem" />
      </div>
      <div class="page-btn">
        <van-icon name="bullhorn-o" color="#ffffff" size="0.5rem" @click="msg" />

        <van-icon name="service-o" color="#ffffff" size="0.5rem" @click="help" />
      </div>
    </div>
    <div class="swipe-bg" :style="`background:${basic.mobileHeadBg?basic.mobileHeadBg:'#ff6034'}`"></div>
    <div class="page-swiper">
      <div class="skeleton-swiper"></div>
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="item in swipeList" :key="item.id">
          <a :href="item.url" target="_blank">
            <img :src="item.img" alt="GEEK" />
          </a>
        </van-swipe-item>
      </van-swipe>
    </div>

    <div class="page-hot" v-show="skeleton.hot">
      <div class="hot-head">
        限时促销
        <div class="title-r">
          <span class="title-tag left">折</span>
          <span class="title-tag right">扣</span>
        </div>
      </div>
      <div class="hot-content">
        <div class="skeleton-hot" v-for="index in 4" :key="index">
          <div class="skeleton-img"></div>
          <span class="skeleton-price"></span>
        </div>
      </div>
      <div style="clear: both"></div>
    </div>
    <div class="page-hot" v-if="disShopList.length != 0">
      <div class="hot-head">
        限时促销
        <div class="title-r">
          <span class="title-tag left">折</span>
          <span class="title-tag right">扣</span>
        </div>
      </div>
      <div class="hot-content">
        <div class="skeleton-hot" v-for="index in 4" :key="index" v-show="skeleton.hot">
          <div class="skeleton-img"></div>
          <span class="skeleton-price"></span>
        </div>

        <div class="hot-item" v-for="item in disShopList" :key="item.id" @click="$router.push('/m/details/' + item.id)">
          <div class="hot-img">
            <img :src="item.front" alt="GEEK" />
          </div>
          <span class="new-price">¥ {{ item.newPrice }}</span>
          <span class="new-price init">¥ {{ item.price }}</span>
        </div>
      </div>
      <div style="clear: both"></div>
    </div>

    <div class="page-goods">
      <!-- <img
        class="tit-img"
        src="//img12.360buyimg.com/img/s750x70_jfs/t1/148857/1/16777/13220/5fc9f9d0E734c0ee5/88c99cdbe410e58a.png"
      /> -->

      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :offset="600" @load="onLoad">
        <div class="goods-content">
          <div class="skeleton-goods" v-for="index in 4" :key="index" v-show="skeleton.goods">
            <div class="skeleton-img"></div>
            <div class="skeleton-title" :style="`width:${Math.random() * (80 - 20) + 20}%`"></div>
            <div class="skeleton-title" :style="`width:${Math.random() * (80 - 20) + 20}%`"></div>
          </div>

          <div class="goods-item" v-for="item in shopList" :key="item.id"
            @click="$router.push('/m/details/' + item.id)">
            <img class="goods-img" :src="item.front" alt="GEEK" />
            <div class="goods-title">
              <van-tag round type="danger" v-show="item.hot == 1">推荐</van-tag>{{ item.name }}
            </div>
            <div class="goods-price">
              <div class="big-price">¥&nbsp;{{ item.price }}</div>
            </div>
          </div>
        </div>
      </van-list>
    </div>


    <div class="page-footer" :style="`margin-bottom: ${basic.isShow_tabbar == 1 ? '1rem' :''};`">
      <ul class="common-links" v-html="basic.link"></ul>

      <div class="common-copyright" v-html="basic.copy"></div>
    </div>
    <Menu></Menu>
  </div>
</template>

<script>
  import {
    getSwipe,
    getDisShop,
    getShop,
    getSystem
  } from "@/api/index";
  import {
    Dialog,
    Notify
  } from "vant";

  export default {
    data() {
      return {
        swipeList: [],
        disShopList: [],
        shopList: [],
        pageIndex: 1,
        loading: false,
        finished: false,
        basic: {},
        skeleton: {
          hot: true,
          goods: true,
        },
      };
    },
    created() {
      this._getSwipe();
      this._getDisShop();
      this._getShop();
      this._getSystem();
    },
    methods: {
      // 加载列表
      onLoad() {
        this.pageIndex = this.pageIndex + 1;
        this.loading = true
        getShop({
          pageIndex: this.pageIndex,
          name: "",
        }).then((res) => {
          // this.shopList = res.data.data;
          if (res.data.data.length == 0) {
            this.finished = true;
          }
          let _this = this;
          res.data.data.map(function (item) {
            _this.shopList.push(item);
          });
          this.loading = false;
        });
      },
      // 获取轮播图
      _getSwipe() {
        getSwipe().then((res) => {
          this.swipeList = res.data;
        });
      },
      // 获取折扣商品
      _getDisShop() {
        getDisShop().then((res) => {
          this.disShopList = res.data;
          this.skeleton.hot = false;
        });
      },
      // 获取商品
      _getShop() {
        getShop({
          pageIndex: this.pageIndex,
          name: "",
        }).then((res) => {
          this.shopList = res.data.data;
          this.skeleton.goods = false;
        });
      },
      // 获取设置
      _getSystem() {
        getSystem().then((res) => {
          this.basic = res.data;
          this.$store.state.basic = res.data;
        });
      },
      // 客服弹窗
      help() {
        Dialog.alert({
          title: "帮助中心",
          message: this.basic.help_content,
        }).then(() => {});
      },
      // 公告弹窗
      msg() {
        Notify({
          type: "success",
          message: this.basic.announce ? this.basic.announce : "暂无通知",
        });
      },
    },
  };
</script>

<style lang="less" scoped>
  @import "../../../../assets/css/clean.css";
  @deep: ~">>>";

  .page-template {
    background-color: rgb(245, 246, 247);
    min-height: 100vh;
    position: relative;
    overflow: hidden;

    .page-head {
      height: 1rem;
      // background: #1ac6c8;
      // background: linear-gradient(to right, #ff6034, #ee0a24);
      display: block;
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      z-index: 1000;
      padding: 0 10px;

      .page-name {
        display: inline-block;
        color: #ffffff;
        font-weight: normal;
        line-height: 1rem;
        margin: 0;
        padding: 0;
        font-size: 0.4rem;
      }

      .page-search {
        position: relative;
        display: inline-block;
        margin-top: 0.25rem;
        width: 5.5rem;
        height: 0.5rem;

        .van-icon {
          position: absolute;
          left: 4px;
          top: 2px;
        }

        .head-inp {
          border-radius: 0.25rem;
          width: 5.5rem;
          height: 0.5rem;
          font-size: 0.24rem;
          padding: 0 10px 0 0.6rem;
          background: #ffffff;
        }
      }

      .page-btn {
        float: right;
        margin-top: 0.25rem;
        height: 0.5rem;

        .van-icon {
          margin: 0 0.1rem;
        }
      }
    }

    .swipe-bg {
      // background: #1ac6c8;
      // background: linear-gradient(to right, #ff6034, #ee0a24);
      position: absolute;
      top: 0;
      left: -25%;
      height: 2.8rem;
      width: 150%;
      border-bottom-left-radius: 100%;
      border-bottom-right-radius: 100%;
    }

    .page-swiper {
      margin-top: 1rem;
      height: 2.8rem;

      .my-swipe {
        margin: 0 10px;
      }

      img {
        width: 100%;
        height: 2.8rem;
        border-radius: 8px;
      }
    }

    .page-hot {
      background: #ffffff;
      margin: 10px;
      box-shadow: rgba(116, 116, 116, 0.08) 0px 0px 10px 0px;
      border-radius: 10px;

      .hot-head {
        height: 0.7rem;
        line-height: 0.7rem;
        padding: 0 10px;
        font-size: 0.31rem;

        .title-r {
          float: right;

          .title-tag {
            border: 1px solid red;
            vertical-align: middle;
            font-size: 0.24rem;
          }

          .left {
            background: red;
            color: #ffffff;
            padding: 2px 2px 2px 4px;
            border-radius: 50% 0 0 50%;
          }

          .right {
            color: red;
            padding: 2px 4px 2px 2px;
            border-radius: 0 50% 50% 0;
          }
        }
      }

      .hot-content {
        .skeleton-hot {
          width: 25%;
          float: left;
          margin-bottom: 0.1rem;
          -webkit-animation: van-skeleton-blink 1.2s ease-in-out infinite;
          animation: van-skeleton-blink 1.2s ease-in-out infinite;

          .skeleton-img {
            width: 1.4rem;
            height: 1.4rem;
            margin: 0 10px;
            background-color: #f2f3f5;
            float: left;
            border-radius: 0.1rem;
          }

          .skeleton-price {
            display: inline-block;
            margin: 0 10px;
            height: 0.2rem;
            width: 1.4rem;
            border-radius: 0.04rem;
            background-color: #f2f3f5;
          }
        }

        .hot-item {
          width: 25%;
          float: left;
          margin-bottom: 0.1rem;

          .hot-img {
            padding: 0 10px;
            height: 1.4rem;
            margin-bottom: 0.1rem;

            img {
              width: 100%;
              height: 1.4rem;
              border-radius: 0.1rem;
            }
          }

          .new-price {
            display: block;
            color: #f2270c;
            font-size: 0.26rem;
            line-height: 0.3rem;
            height: 0.3rem;
            font-weight: 600;
            text-align: center;
            font-family: JDZhengHT-EN-Regular;
          }

          .init {
            text-decoration: line-through;
            font-size: 0.24rem;
            font-weight: 1;
            color: #999;
          }
        }
      }
    }



    .page-goods {
      margin: 10px 5px;
      min-height: 400px;
      margin-bottom: 0.2rem;

      @{deep}.van-list__finished-text {
        font-size: .28rem;
      }

      .tit-img {
        width: 100%;
        margin-bottom: 0.05rem;
      }

      .goods-content {
        // display: flex; 
        // flex-direction: row;
        // justify-content: space-between; 
        // flex-wrap: wrap;
        // -moz-column-count: 2;
        // -webkit-column-count: 2;
        // column-count: 2;

        .skeleton-goods {
          // -moz-page-break-inside: avoid;
          // -webkit-column-break-inside: avoid;
          // break-inside: avoid;
          float: left;
          width: 46%;
          margin: 0 2%;
          margin-bottom: 0.2rem;
          background: #ffffff;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: rgba(116, 116, 116, 0.08) 0px 0px 10px 0px;
          -webkit-animation: van-skeleton-blink 1.2s ease-in-out infinite;
          animation: van-skeleton-blink 1.2s ease-in-out infinite;
          padding-bottom: 0.1rem;

          .skeleton-img {
            margin: 0.2rem;
            height: 3.25rem;
            border-radius: 0.1rem;
            background-color: #f2f3f5;
          }

          .skeleton-title {
            margin: 0.1rem 0.2rem;
            height: 0.2rem;
            background-color: #f2f3f5;
          }
        }

        .goods-item {
          // -moz-page-break-inside: avoid;
          // -webkit-column-break-inside: avoid;
          // break-inside: avoid;
          float: left;
          width: 46%;
          margin: 0 2%;
          margin-bottom: 0.2rem;
          background: #ffffff;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: rgba(116, 116, 116, 0.08) 0px 0px 10px 0px;

          .goods-img {
            width: 100%;
            height: 3.45rem;
          }

          .goods-title {
            font-size: 0.28rem;
            padding: 0 0.1rem;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            /* 行数 */
            -webkit-box-orient: vertical;
            overflow: hidden;
            margin-top: 0.1rem;

            .van-tag {
              padding: 1px 2px;
              margin-right: 4px;
              font-size: .24rem;
              line-height: .32rem;
            }
          }

          .goods-price {
            padding: 0.15rem 0.2rem;
            overflow: hidden;

            .big-price {
              float: left;
              // display: inline-block;
              font-family: JDZhengHT-EN-Regular;
              color: red;
              font-weight: 600;
              font-size: 0.3rem;
            }

            .van-tag {
              float: right;
              padding: 2px 4px;
              vertical-align: middle;
            }
          }
        }
      }

      .goods-content::after {
        content: "";
        display: table;
        clear: both;
      }
    }

    .page-footer {
      margin: 0 auto;
      background-color: #fff;


      .common-links {
        box-sizing: border-box;
        padding: 0.3rem 0;
        border-bottom: 1px solid #e5e5e5;
        padding: .2rem;
        text-align: center;
        // display: flex;
        // justify-content: space-around;

        @{deep} a {
          font-size: .28rem;
          margin: 0 .1rem;
        }
      }

      .common-copyright {
        text-align: center;
        color: #848689;
        font-size: .28rem;
        padding: 2vw;
      }
    }

    .mrb1 {
      margin-bottom: 1rem;
    }
  }
</style>